<template>
  <div class="borrowMoneylist">
    <!-- 表单搜索 start -->
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="formData"
      @Refresh="onHandleRefresh"
      @search="onSearch"
    >
      <el-button
        type="warning"
        icon="el-icon-download"
        @click="onHandleExport"
        slot="right"
        >导出</el-button
      >
    </Filtersearch>
    <!-- 表单搜索 end -->

    <!-- 列表 start -->
    <div class="table-wrap">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
      >
        <el-table-column
          label="集配中心"
          prop="logisticBusinessValue"
          align="center"
        >
        </el-table-column>
        <el-table-column label="添加时间" prop="create_time" align="center">
        </el-table-column>
        <el-table-column label="供货日期" prop="sales_cycle" align="center">
        </el-table-column>
        <el-table-column label="添加来源" prop="modifyChannelValue" align="center">
        </el-table-column>
        <el-table-column label="添加人" prop="operator_name" align="center">
        </el-table-column>
        <el-table-column label="商品名称" prop="sku_name" align="center">
        </el-table-column>
        <el-table-column label="货号" prop="sku_code" align="center">
        </el-table-column>
        <el-table-column label="供应商" prop="supplier" align="center">
        </el-table-column>
        <el-table-column label="采购" prop="buyer" align="center">
        </el-table-column>
      </el-table>
    </div>
    <!-- 列表 end -->

    <!-- 分页 start -->
    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        :current-page="formData.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import Filtersearch from "@/components/Filtersearch.vue";
import cloneDeep from "lodash/cloneDeep";
export default {
  name: "bestSellingAdd",
  components: {
    Filtersearch,
  },
  data() {
    return {
      Filtersearchlist: [
        {
          type: "select",
          name: "集配中心",
          clearable: true,
          filterable: true,
          model: "logisticBusinessId",
          placeholder: "请选择集配中心",
          label: "name",
          value: "id",
          selectoption: [],
        },
        {
          type: "daterange",
          name: "添加时间",
          clearable: true,
          model: "timeRange",
          startmodel: "startTime",
          endmodel: "endTime",
          startplaceholder: "开始时间",
          endplaceholder: "结束时间",
        },
        {
          type: "input",
          name: "添加人",
          clearable: true,
          model: "operator",
          placeholder: "请输入添加人",
        },
        {
          type: "input",
          name: "货号",
          clearable: true,
          model: "skuCode",
          placeholder: "请输入货号",
        },
      ],
      loading: false,
      btndisabled: false,
      formData: {
        logisticBusinessId: "",
        startTime: "",
        endTime: "",
        operator: "",
        skuCode: "",
        page: 1,
        pageSize: 10,
      },
      formDataClone: {},
      tableData: [],
      total: 0,
    };
  },
  created() {
    this.getBusinessList();
  },
  mounted() {
    this.onInitData();
  },
  methods: {
    getBusinessList() {
      this.$api.general.businessList().then((res) => {
        this.Filtersearchlist[0].selectoption = res.data;
      });
    },
    ajaxGetTableList() {
      this.loading = true;
      this.$api.bestSelling
        .getHotSkuRecord(this.formData)
        .then((res) => {
          this.tableData = res.data.data || [];
          this.total = res.data.total || 0;
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    onInitData() {
      this.formDataClone = cloneDeep(this.formData);
      this.ajaxGetTableList();
    },
    onHandleRefresh() {
      this.formData = {
        ...this.formDataClone,
      };
      this.ajaxGetTableList();
    },
    onSearch(e) {
      this.formData = e;
      this.formData.page = 1;
      this.ajaxGetTableList();
    },
    onHandleSizeChange(val) {
      this.formData.pageSize = val;
      this.ajaxGetTableList();
    },
    onHandleCurrentChange(val) {
      this.formData.page = val;
      this.ajaxGetTableList();
    },
    //导出
    onHandleExport() {
      this.$api.bestSelling.getHotSkuRecordExport(this.formData).then((res) => {
        console.log(res);
        this.goExportCenter();
      });
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
  },
};
</script>
<style lang="scss">
.borrowMoneylist {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  .table-wrap {
    flex-grow: 1;
    overflow-y: hidden;
    .text-btn {
      color: $theme-color;
      cursor: pointer;
    }
  }

  .fy {
    box-sizing: border-box;
    padding: 10px 20px;
  }
}
</style>
